module.exports = __webpack_public_path__ + "img/tx.361f83b1.png";